/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_CityInputs */

const en_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

const fr_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ville`)
};

const es_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciudad`)
};

const it_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citta`)
};

const nl_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stad`)
};

const pl_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miasto`)
};

const fi_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaupunki`)
};

const da_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By`)
};

const sv_resume_editor_city = /** @type {(inputs: Resume_Editor_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stad`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Resume_Editor_CityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_city = /** @type {((inputs?: Resume_Editor_CityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_CityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_city(inputs)
	if (locale === "fr") return fr_resume_editor_city(inputs)
	if (locale === "es") return es_resume_editor_city(inputs)
	if (locale === "it") return it_resume_editor_city(inputs)
	if (locale === "nl") return nl_resume_editor_city(inputs)
	if (locale === "pl") return pl_resume_editor_city(inputs)
	if (locale === "fi") return fi_resume_editor_city(inputs)
	if (locale === "da") return da_resume_editor_city(inputs)
	if (locale === "sv") return sv_resume_editor_city(inputs)
	return en_resume_editor_city(inputs)
});